module.exports = __webpack_public_path__ + "img/dark_ic_new_page.13039d16.png";